import { initFancybox } from "./lib-2sxc-fancybox";

var winAny = window as any;
winAny.appReferences ??= {};
winAny.appReferences.init ??= initFancybox;

document.querySelectorAll('[data-reffilter]').forEach(function(item, index) {
  item.addEventListener ("click", function (e) {
    var filterElem = e.currentTarget as HTMLElement;
    var filterSlug = filterElem.dataset.reffilter;
    var clearFilterElem = document.querySelector('.clear-filter') as HTMLElement;

    showFilteredItems(filterSlug)

    if(filterSlug != "") {
      clearFilterElem.style.display = "block";
    } else {
      clearFilterElem.style.display = "none";
    }
  })
});

function showFilteredItems(slug: string) {
  document.querySelectorAll('[data-refcategory]').forEach(function(item, index) {
    item.classList.remove('hidden');
  })

  if(slug != "") {
    document.querySelectorAll('[data-refcategory]:not(.' + slug + ')').forEach(function(item, index) {
      item.classList.add('hidden');
    })
  }
}

